export default `
  fragment BookingAttendeesProfile on Profile {
    customerId
    gmNumber
    civility
    firstName
    lastName
    unicodeFirstName
    unicodeLastName
    dateOfBirth
  }
`;
